import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'components/AppSafeLink/AppSafeLink';
import IconChevron from '../../components/Icons/IconChevron';
import { linkByTypeAs } from '../../utils/cjsutils';
import contributionsQuery from './contributions.gql';
import fetcher from '../../utils/fetcher';

export default class ContributionsContainer extends Component {
  static propTypes = {
    initialCollection: PropTypes.object,
    initialPage: PropTypes.number,
    slug: PropTypes.string,
    id: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.fetcher = fetcher;
    this.state = {
      collection: props.initialCollection,
      currentPage: props.initialPage || 1,
      appParam: this.getAppParam(),
    };
  }

  getAppParam() {
    if (typeof window === 'undefined') return false;
    const query = window.location.search;
    return new URLSearchParams(query).has('app');
  }

  urlSlug(pageNum) {
    const basePath = `/people/${this.props.slug}/${pageNum}`;
    return this.state.appParam ? `${basePath}?app` : basePath;
  }

  async handleQuery(pageNum) {
    pageNum = parseInt(pageNum);
    const { slug, id } = this.props;
    const result = await this.fetcher(contributionsQuery, {
      contentAreaSlug: process.env.CONTENT_AREA_SLUG,
      slug,
      pageNum,
      id,
    });
    this.setState({
      collection: result.profile.collection,
      currentPage: pageNum,
    });
    window.history.pushState(null, null, this.urlSlug(pageNum));
  }

  render() {
    return (
      <div>
        <h3>Recent Contributions</h3>
        <ul className="bullet-list">
          {this.state.collection.items.map((item) => {
            const linkAs = linkByTypeAs(item);
            return (
              <li key={item.id}>
                <Link href={linkAs} className="contributer">
                  {item.title}
                  {item.descriptionText && <div>{item.descriptionText}</div>}
                </Link>
              </li>
            );
          })}
        </ul>
        <div className="profile_pagination">
          <nav className="pagination">
            <div className="pagination_list">
              {this.state.currentPage > 1 && (
                <div className="pagination_page pagination_page-prev">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={(e) => {
                      e.preventDefault();
                      this.handleQuery(this.state.currentPage - 1);
                    }}
                  >
                    <IconChevron
                      direction="left"
                      color="var(--color-white)"
                      decorative
                    />
                    <span>Prev</span>
                  </button>
                </div>
              )}
              {this.state.currentPage < this.state.collection.totalPages && (
                <div className="pagination_page pagination_page-next">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={(e) => {
                      e.preventDefault();
                      this.handleQuery(this.state.currentPage + 1);
                    }}
                  >
                    <span>Next</span>
                    <IconChevron
                      direction="right"
                      color="var(--color-white)"
                      decorative
                    />
                  </button>
                </div>
              )}
            </div>
          </nav>
        </div>
      </div>
    );
  }
}
